const VERBOSE_DEBUG_CAPTURE_KEY = 'wereader.debugLogs.verboseDebug';
const VERBOSE_DEBUG_QUERY_PARAM = 'debugLogs';

/** Prefixes we always capture regardless of level. */
const CAPTURE_PREFIXES = [
  '[locationOf]',
  '[manager.display]',
  '[footnote]',
  '[footnote-link]',
  '[hereBeDragons]',
  '[display-recovery]',
  '[paginated.next]',
  '[paginated.prev]',
  '[flow-change]',
  '[reader-position-checkpoint]',
  '[reader-navigation]',
  '[reader-indexing]',
  '[paginated.position-restore]',
  '[search-nav]',
  '[library-search]',
  '[customSelection]',
  '[dictionary-share]',
  '[note-sync]',
];

function hasCapturePrefix(args: unknown[]): boolean {
  return args.some(
    (arg) =>
      typeof arg === 'string' &&
      CAPTURE_PREFIXES.some((prefix) => arg.startsWith(prefix)),
  );
}

function isVerboseDebugCaptureEnabled(): boolean {
  const root = globalThis as typeof globalThis & {
    __WEREADER_VERBOSE_DEBUG_LOGS__?: boolean;
  };
  if (root.__WEREADER_VERBOSE_DEBUG_LOGS__) {
    return true;
  }

  try {
    if (
      typeof localStorage !== 'undefined' &&
      localStorage.getItem(VERBOSE_DEBUG_CAPTURE_KEY) === '1'
    ) {
      return true;
    }
  } catch {
    // Ignore storage access failures in private or restricted contexts.
  }

  try {
    if (
      typeof window !== 'undefined' &&
      new URLSearchParams(window.location.search).has(VERBOSE_DEBUG_QUERY_PARAM)
    ) {
      return true;
    }
  } catch {
    // Ignore malformed or unavailable location data.
  }

  return false;
}

export function shouldCaptureConsoleEntryForReport(lvl: string, args: unknown[]): boolean {
  if (!args.length) {
    return false;
  }
  if (lvl === 'warn' || lvl === 'error') {
    return true;
  }
  if (hasCapturePrefix(args)) {
    return true;
  }
  return lvl === 'debug' && isVerboseDebugCaptureEnabled();
}
